/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui';
import { hoverTransition } from '../../../../utils/styles/general';



/* ++++++++++ --------------- CONTROLS : STYLES --------------- ++++++++++ */
export default {
	controls: {
		width: '100%',
		padding: replacePXinStringWithEM(`28px 20px 20px`),
		'& #sidebar-controls-inner': {
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
			width: '100%',
			minHeight: pxToEm(36),
			'& .name-insticator-icon': {
				flex: `0 0 ${pxToEm(39)}`, // needed so elements don't collpase
				marginLeft: pxToEm(4),
				extend: hoverTransition(),
				'&:hover': { filter: 'brightness(65%)' }
			},
      '& .logo': {
        height: pxToEm(32)
      },
		},
		'&.sidebarOpen': {
			'&-false': {
				'& .asidetoggle': {
					display: 'none'
				}
			}
		}
	}
}; 